var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIconAuth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.829 0.860119C20.7584 -0.111268 18.2248 0.123243 16.0851 1.62186C12.2514 4.30688 11.7088 7.43154 9.63718 9.80554C7.56555 12.1795 6.99157 12.3175 4.42143 13.7471C1.36206 15.4489 -0.338153 19.2894 0.741681 22.3915C1.81806 25.4447 3.29207 27.7425 7.32456 29.1015C11.3081 30.4638 12.431 27.7625 16.7243 28.9815C21.0176 30.2005 23.8873 33.3646 26.9011 32.582C30.0614 31.7613 35.0401 29.4639 35.0738 22.7108C35.0933 18.8033 30.8558 16.3423 30.4851 12.4804C30.1145 8.61852 30.4509 6.84429 29.4327 5.16913C27.9346 2.70469 26.3381 1.6539 23.829 0.860119Z",
    fill: "white",
    fillOpacity: 0.16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 13L19 17L23 21",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21L19 17L15 13",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconAuth);
export default __webpack_public_path__ + "static/media/close-icon-auth.197fed157a8c61feb1ed4e2fc487e003.svg";
export { ForwardRef as ReactComponent };